










































































































































import Vue from "vue";

import { GetPredictiveMaintenanceScheduleResData } from "@/model/communication/predictiveMaintenance/GetPredictiveMaintenanceScheduleResData";
import { GetPredictiveMaintenanceScheduleCommand } from "@/model/communication/predictiveMaintenance/GetPredictiveMaintenanceScheduleCommand";
import {
    EditPredictiveMaintenanceScheduleCommand,
    EditPredictiveMaintenanceScheduleReqData,
} from "@/model/communication/predictiveMaintenance/EditPredictiveMaintenanceScheduleCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { mapGetters } from "vuex";
import moment from "moment";

export default Vue.extend({
    data() {
        return {
            predictionScheduleTime: null,
            lastTrainingDate: null,
            trainingScheduleDays: null,
            trainingScheduleTime: null,
            loading: false,
            showScheduleDialog: false,
            newSchedule: {
                predictionScheduleTime: null,
                lastTrainingDate: null,
                trainingScheduleDays: 0,
                trainingScheduleTime: null,
            },
            predictionTimeMenu: false,
            trainingTimeMenu: false,
            availablePredictionScheduleOptions: [
                {
                    text: this.$t("predictiveMaintenance.notSetted"),
                    value: 0,
                },
                {
                    text: this.$t("predictiveMaintenance.daily"),
                    value: 1,
                },
            ],
            predictionScheduleSelect: 0,
            availableTrainingScheduleOptions: [
                {
                    text: this.$t("predictiveMaintenance.notSetted"),
                    value: 0,
                },
                {
                    text: this.$t("predictiveMaintenance.setted"),
                    value: 1,
                },
            ],
            trainingScheduleSelect: 0,
        };
    },
    methods: {
        async sendRequest() {
            this.loading = true;
            try {
                var response: GetPredictiveMaintenanceScheduleResData = await new GetPredictiveMaintenanceScheduleCommand().execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.predictionScheduleTime = response.predictionScheduleTime;
                    this.lastTrainingDate = response.lastTrainingDate;
                    this.trainingScheduleDays = response.trainingScheduleDays;
                    this.trainingScheduleTime = response.trainingScheduleTime;
                    this.newSchedule.predictionScheduleTime = this.predictionScheduleTime;
                    this.newSchedule.lastTrainingDate = this.lastTrainingDate;
                    this.newSchedule.trainingScheduleDays = this.trainingScheduleDays;
                    this.newSchedule.trainingScheduleTime = this.trainingScheduleTime;
                }
            } catch (e) {
                console.error("Something went wrong during GetPredictiveMaintenanceScheduleCommand", e);
            }
            this.loading = false;
        },
        async save() {
            this.loading = true;
            try {
                if (this.predictionScheduleSelect == 0) this.newSchedule.predictionScheduleTime = null;
                if (this.trainingScheduleSelect == 0) {
                    this.newSchedule.trainingScheduleDays = 0;
                    this.newSchedule.trainingScheduleTime = null;
                }
                if (!this.isValid) throw "Invalid operation";
                let reqData = new EditPredictiveMaintenanceScheduleReqData(this.newSchedule);
                var response = await new EditPredictiveMaintenanceScheduleCommand(reqData).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.predictionScheduleTime = this.newSchedule.predictionScheduleTime;
                    this.trainingScheduleDays = this.newSchedule.trainingScheduleDays;
                    this.trainingScheduleTime = this.newSchedule.trainingScheduleTime;
                }
            } catch (e) {
                console.error("Something went wrong during GetPredictiveMaintenanceScheduleCommand:", e);
            }
            this.showScheduleDialog = false;
            this.loading = false;
        },
        getAlertMessageId() {
            if (
                this.predictionScheduleTime != null &&
                this.predictionScheduleTime != undefined &&
                this.trainingScheduleDays > 0 &&
                this.trainingScheduleTime != null &&
                this.trainingScheduleTime != undefined
            )
                return {
                    id: "predictiveMaintenance.schedule",
                    extra: {
                        predictionTime: moment(this.predictionScheduleTime, "HH:mm:ss").format(this.userTimeFormat.timeFormat),
                        trainingDays: this.trainingScheduleDays,
                        trainingTime: moment(this.trainingScheduleTime, "HH:mm:ss").format(this.userTimeFormat.timeFormat),
                        nextRetrainingOccurrence: this.getNextOccurence(
                            this.lastTrainingDate == null ? new Date() : this.lastTrainingDate,
                            moment(this.trainingScheduleTime, "HH:mm:ss"),
                            this.lastTrainingDate == null ? 0 : this.trainingScheduleDays
                        ),
                    },
                };

            if (
                this.predictionScheduleTime != null &&
                this.predictionScheduleTime != undefined &&
                (this.trainingScheduleDays == 0 || this.trainingScheduleTime == null || this.trainingScheduleTime == null)
            )
                return {
                    id: "predictiveMaintenance.noScheduleTraining",
                    extra: { predictionTime: moment(this.predictionScheduleTime, "HH:mm:ss").format(this.userTimeFormat.timeFormat) },
                };
            if (this.trainingScheduleDays == 0 || this.trainingScheduleTime == null || this.trainingScheduleTime == null)
                return {
                    id: "predictiveMaintenance.noSchedule",
                };
            if (this.predictionScheduleTime == null || this.predictionScheduleTime == undefined)
                return {
                    id: "predictiveMaintenance.noSchedulePrediction",
                    extra: {
                        trainingDays: this.trainingScheduleDays,
                        trainingTime: moment(this.trainingScheduleTime, "HH:mm:ss").format(this.userTimeFormat.timeFormat),
                        nextRetrainingOccurrence: this.getNextOccurence(
                            this.lastTrainingDate == null ? new Date() : this.lastTrainingDate,
                            moment(this.trainingScheduleTime, "HH:mm:ss"),
                            this.lastTrainingDate == null ? 0 : this.trainingScheduleDays
                        ),
                    },
                };
            return null;
        },
        getNextOccurence(fromAsDate, scheduleTime, daysAsString) {
            let from = moment(fromAsDate).toDate();
            let days = parseInt(daysAsString);
            for (let i = 0; i < 2; i++) {
                let testingOccurence = new Date(from.getFullYear(), from.getMonth(), from.getDate(), scheduleTime.hour(), scheduleTime.minutes(), 0);
                testingOccurence.setDate(testingOccurence.getDate() + days + i);
                if (testingOccurence < new Date()) {
                    testingOccurence = new Date();
                    testingOccurence = new Date(
                        testingOccurence.getFullYear(),
                        testingOccurence.getMonth(),
                        testingOccurence.getDate(),
                        scheduleTime.hour(),
                        scheduleTime.minutes(),
                        0
                    );
                    if (testingOccurence < new Date()) testingOccurence.setDate(testingOccurence.getDate() + 1);
                }

                if (testingOccurence > from) {
                    return moment(testingOccurence).format(this.userDateFormat);
                }
            }
        },
        openDialog() {
            if (this.predictionScheduleTime == null || this.predictionScheduleTime == undefined) this.predictionScheduleSelect = 0;
            else this.predictionScheduleSelect = 1;
            if (this.trainingScheduleDays > 0 && this.trainingScheduleTime != null && this.trainingScheduleTime != undefined) this.trainingScheduleSelect = 1;
            else this.trainingScheduleSelect = 0;
            this.showScheduleDialog = true;
        },
    },
    computed: {
        ...mapGetters(["userTimeFormat", "userDateFormat"]),

        isValid() {
            if (this.newSchedule == null || this.newSchedule == undefined || Object.keys(this.newSchedule).length == 0) return true;
            if (this.predictionScheduleSelect == 1 && (this.newSchedule.predictionScheduleTime == null || this.newSchedule.predictionScheduleTime == undefined)) return false;
            if (
                this.trainingScheduleSelect == 1 &&
                (this.newSchedule.trainingScheduleTime == null || this.newSchedule.trainingScheduleTime == undefined || this.newSchedule.trainingScheduleDays <= 0)
            )
                return false;
            return true;
        },
        alertType() {
            let alertMessage = this.getAlertMessageId();
            switch (alertMessage.id) {
                case "predictiveMaintenance.schedule":
                    return "info";
                case "predictiveMaintenance.noSchedule":
                    return "error";
                case "predictiveMaintenance.noScheduleTraining":
                case "predictiveMaintenance.noSchedulePrediction":
                    return "warning";
            }
            return "";
        },
        alertMessage() {
            let alertMessage = this.getAlertMessageId();
            if (alertMessage.extra) return this.$t(alertMessage.id, alertMessage.extra);
            return this.$t(alertMessage.id);
        },
        predictionScheduleTimeFormatted() {
            if (this.newSchedule.predictionScheduleTime == null || this.newSchedule.predictionScheduleTime == undefined) return this.newSchedule.predictionScheduleTime;
            return moment(this.newSchedule.predictionScheduleTime, "HH:mm:ss").format(this.userTimeFormat.timeFormat);
        },
        trainingScheduleTimeFormatted() {
            if (this.newSchedule.trainingScheduleTime == null || this.newSchedule.trainingScheduleTime == undefined) return this.newSchedule.trainingScheduleTime;
            return moment(this.newSchedule.trainingScheduleTime, "HH:mm:ss").format(this.userTimeFormat.timeFormat);
        },
    },
    created() {
        this.sendRequest();
    },
});
